export interface PhoneNumberInput {
  code: string;
  number: string;
}
